import axios from "axios";
import { getSessionId, getVisitorId } from "./crmTracking";

const CONTACT_LEAD_ENDPOINT = "https://gatewaysistemas.com.br/gatewayApi/api/contatolead/contatolead";

const getCampaignData = () => {
  if (typeof window === "undefined") {
    return {
      origem: "lpcta",
      campanha: "",
    };
  }

  const params = new URLSearchParams(window.location.search);
  const origem = params.get("utm_source") || "lpcta";
  const campanha = params.get("utm_campaign") || "";

  return {
    origem,
    campanha,
  };
};

export const submitLeadContact = async ({
  nome,
  email,
  telefone,
  observacao = "",
  aceitouTermos = null,
}) => {
  if (typeof window === "undefined") {
    return false;
  }

  const { origem, campanha } = getCampaignData();

  const payload = {
    nome,
    email,
    telefone,
    origem,
    campanha,
    page_url: window.location.href,
    session_id: getSessionId(),
    visitor_id: getVisitorId(),
    status: "novo",
    ip_address: null,
    user_agent: window.navigator.userAgent,
    observacao,
    aceitou_termos: aceitouTermos,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  };

  try {
    const response = await axios.post(CONTACT_LEAD_ENDPOINT, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return Boolean(response?.data);
  } catch (error) {
    console.error("Erro ao cadastrar lead:", error);
    return false;
  }
};
